class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = document.getElementById('cart-notification');

    // Safeguard: Ensure notification exists
    if (!this.notification) {
      console.warn("Cart notification element not found!");
      return;
    }

    this.productId = null;

    // Optional: Uncomment these if you plan to use them
    // this.onBodyClick = this.handleBodyClick.bind(this);
    // this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    // this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
    //   closeButton.addEventListener('click', this.close.bind(this))
    // );
  }

  renderContents(parsedState) {
    if (!parsedState || !parsedState.sections) {
      console.warn("Parsed state or sections not provided in renderContents");
      return;
    }

    // Clear default notification content if present
    const defaultNotification = document.getElementById("cart-notification-default");
    if (defaultNotification) {
      defaultNotification.innerHTML = "";
    }

    this.productId = parsedState.id;

    // Render each section safely
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.getElementById(section.id);
      if (!sectionElement) {
        console.warn(`Element with ID ${section.id} not found in DOM`);
        return;
      }

      const sectionHtml = parsedState.sections[section.id];
      if (!sectionHtml) {
        console.warn(`Section HTML not found for ID ${section.id}`);
        return;
      }

      const innerHtml = this.getSectionInnerHTML(sectionHtml, section.selector);
      if (!innerHtml) {
        console.warn(`Unable to parse HTML for section ${section.id}`);
        return;
      }

      sectionElement.innerHTML = innerHtml;
    });

    // Expand the cart icon dropdown if necessary
    const dropDownIcon = document.querySelector('#cart-icon-bubble');
    if (dropDownIcon && dropDownIcon.getAttribute("aria-expanded") === "false") {
      dropDownIcon.click();
    }
  }

  getSectionsToRender() {
    return [
      { id: 'cart-notification-product' },
      { id: 'cart-notification-button' },
      { id: 'cart-icon-bubble' },
      { id: 'cart-upsell' },
      { id: 'cart-drawer-gift' },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    try {
      const parsedHtml = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector);

      if (!parsedHtml) {
        console.warn(`Selector "${selector}" not found in parsed HTML`);
        return '';
      }

      return parsedHtml.innerHTML;
    } catch (error) {
      console.error("Error parsing HTML:", error);
      return '';
    }
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  // Uncomment if you want to implement open and close logic
  // open() {
  //   this.notification.classList.add('animate', 'active');
  //   this.notification.addEventListener('transitionend', () => {
  //     this.notification.focus();
  //     trapFocus(this.notification);
  //   }, { once: true });
  //   document.body.addEventListener('click', this.onBodyClick);
  // }

  // close() {
  //   this.notification.classList.remove('active');
  //   document.body.removeEventListener('click', this.onBodyClick);
  //   removeTrapFocus(this.activeElement);
  // }
}

customElements.define('cart-notification', CartNotification);
